export function speedConverter(value, unit) {
  switch (unit) {
    case 'km/h':
      return Math.floor(value * 1.852).toFixed(0);
    case 'nd':
    default:
      return Math.floor(value).toFixed(0);
  }
}
export function altitudeConverter(value, unit) {
  switch (unit) {
    case 'ft':
      return Math.floor(value * 3.28084).toFixed(0);
    case 'm':
    default:
      return Math.floor(value).toFixed(0);
  }
}

export function distanceConverter(value, unit) {
  switch (unit) {
    case 'mille':
      return `${
        value / 1.609 < 1 ? parseFloat((value / 1.609).toFixed(3)) : (value / 1.609).toFixed(0)
      }`;
    case 'km':
    default:
      return value < 1 ? `${parseFloat(value.toFixed(3))}` : `${parseFloat(value.toFixed(0))}`;
  }
}

export function speedReverse(value, unit) {
  switch (unit) {
    case 'km/h':
      return value / 1.852;
    case 'nd':
    default:
      return value;
  }
}

export function calculNbG(position) {
  if (
    position !== undefined &&
    position.attributes !== undefined &&
    position.attributes.axisX !== undefined &&
    position.attributes.axisY !== undefined &&
    position.attributes.axisZ !== undefined
  ) {
    return (
      Math.sqrt(
        position.attributes.axisX ** 2 +
          position.attributes.axisY ** 2 +
          position.attributes.axisZ ** 2
      ) / 1000
    ).toFixed(2);
  }

  return null;
}
